import { render } from "./AppTable.vue?vue&type=template&id=30198167&ts=true"
import script from "./AppTable.vue?vue&type=script&lang=ts"
export * from "./AppTable.vue?vue&type=script&lang=ts"

import "./AppTable.vue?vue&type=style&index=0&id=30198167&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__